<template>
  <svg width="100px" height="40px">
    <defs>
      <radialGradient id="grad1" cx="50%" cy="50%" r="150%" fx="50%" fy="50%">
        <stop
          offset="0%"
          style="stop-color:rgb(255,255,255);
      stop-opacity:0"
        />
        <stop offset="100%" style="stop-color:rgb(0,0,0);stop-opacity:1" />
      </radialGradient>
    </defs>
    <g>
      <clipPath id="clipCircle">
        <circle r="17" cx="64" cy="20" />
      </clipPath>
      <rect
        stroke="lightgrey"
        stroke-width="2"
        class="shadow"
        x="0"
        y="0"
        rx="15"
        ry="40"
        width="90"
        height="40"
        fill="white"
      />
      <rect
        stroke="lightgrey"
        stroke-width="2"
        class="shadow"
        x="0"
        y="0"
        rx="15"
        ry="40"
        width="90"
        height="40"
        fill="url(#grad1)"
      />
      <text
        class="text-style"
        x="10"
        y="0"
        style="font-weight: 600;
  font-size: 10pt; font-family: 'Verdana';"
      >
        <tspan x="11" y="17">{{ CountryCode }}</tspan>
        <tspan x="9" y="30">{{ Text }}</tspan>
      </text>

      <image
        xmlns="http://www.w3.org/2000/svg"
        :id="'image-id-' + CountryCode"
        height="50"
        width="50"
        clip-path="url(#clipCircle)"
        x="39"
        y="-5"
        :xlink:href="Url"
      />
      <circle
        :stroke="Color"
        fill="none"
        stroke-width="4"
        r="17"
        cx="64"
        cy="20"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "MapMarker",

  props: {
    CountryCode: String,
    Text: String,
    Color: String,
    Url: String
  }
};
</script>

<style scoped>
.text-style {
  font-weight: 600;
  font-family: "Verdana";
  font-size: 10pt;
  color: "black";
}
</style>
